<template>
   <v-layout align-center justify-center class="editavatar_bg">
        <v-alert v-if="error" :value="true" color="error" icon="error" outline>
            {{ errorMessage }}
        </v-alert> 
        <v-toolbar fixed flat class="transparent" style="color:white;">
            <v-spacer></v-spacer>
            <v-btn dark large @click="turnOnVideo" title="Use Camera" v-show="showCameraButton">
                <v-icon>photo_camera</v-icon>&nbsp;Use Camera
            </v-btn>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Cancel</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm8 md4 :style="isMobile?'position:relative;height:100%;':''">
            <div class="text-xs-center" :style="isMobile?'position: absolute; top: 20%; width: 100%;':''">
                <!-- note, when converting these inline styles to css, used !important then test first in test environment -->
                <video autoplay playsinline muted v-show="showCameraScreen" style="max-width:100%; width:auto; height:auto;"></video>
                <img src="" id="imgMyProfile" v-show="showImage" style="max-width:100%; width:auto; height:auto;">
                <div class="text-xs-center" style="padding:20px;">
                    <vue-dropzone ref="myVueDropzone" 
                        style="height:200px;"
                        id="dropzone" 
                        v-show="showUpload"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="uploadSuccess"
                        v-on:vdropzone-file-added="fileAdded"
                        ></vue-dropzone>
                </div>
            </div>
            <div :class="isMobile?'img-controls':'text-xs-center'">
                <v-btn dark :block="isMobile?true:false"  @click="takeAgain" v-show="showSavePic" title="Take Another">
                    <v-icon>refresh</v-icon>&nbsp;Take Again
                </v-btn>
                <v-btn dark :block="isMobile?true:false"  @click="savePicture" :loading="uploading" v-show="showSavePic" class="primary" title="Save Picture">
                    <v-icon>save</v-icon>&nbsp;Save
                </v-btn>
                <v-btn dark :block="isMobile?true:false"  @click="takeScreenshot" :loading="loadingScreenshot" v-show="showScreenshot" title="Take Picture">
                    <v-icon>linked_camera</v-icon>&nbsp;Take Picture
                </v-btn>
            </div>
        </v-flex> 
    </v-layout>
</template>
<script>
    
import axios from 'axios'
import uploadApi from '@/api/upload.js'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: 'EditAvatar',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,
            loading: false,   
            img: null,
            video: null,
            videoStream: null,
            showCameraButton: true,       
            showCameraScreen: false,
            showSaveCameraPic: false,
            showScreenshot: false,
            showImage: false,
            showSavePic: false,
            showUpload: true,      
            loadingScreenshot: false,
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}Image/upload/avatar`,    //image is already saved as base64
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='subheading'><u>Drop your photo here or click to browse gallery</u><b><br><br><p class='subheading'>Maximum 250 KB</p>",
                maxFiles: 1,
                acceptedFiles: 'image/*', 
                maxFilesize: 0.25,   //250kb
            },
            networkError: false,
            uploading: false,
            error: false,
            errorMessage: '', 
        }
    },
    methods: {
        syncAvatar(imageBase64) {
            this.$store.commit('setAvatar', imageBase64)
            this.$root.$emit('updateUserAvatar','updateUserAvatarHandler')
            this.$root.$emit('updateHeaderAvatar','updateHeaderAvatarHandler')
        },            
        async savePicture() {
            try {
                this.uploading = true

                const imageBase64 = this.toBase64Image(this.img)
                var data = {
                    imageData: imageBase64
                }
                const response = await uploadApi.uploadAvatarBase64String(data)
                if (response && response.status == 200) {   
                    this.syncAvatar(imageBase64)
                    this.$emit('send', null)
                }

                this.uploading = false
                this.closeDialog()
            } catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async uploadSuccess(file, response) {
            try {
                this.loading = true
                this.error = false

                const imageBase64 = file.dataURL
                var data = {
                    imageData: imageBase64
                }
                const response = await uploadApi.uploadAvatarBase64String(data)
                if (response && response.status == 200) {
                    this.$refs.myVueDropzone.removeAllFiles()
                    this.syncAvatar(imageBase64)
                    this.$emit('send', null)
                }

                this.loading = false
                this.closeDialog()
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        toBase64Image(img) {
            // Create an empty canvas element
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            // Copy the image contents to the canvas
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            // Get the data-URL formatted image
            // Firefox supports PNG and JPEG. You could check img.src to
            // guess the original format, but be aware the using "image/jpg"
            // will re-encode the image.
            return canvas.toDataURL("image/png")
        },
        async takeScreenshot() {
            this.showImage = true

            this.img = document.getElementById('imgMyProfile')
            this.canvas = document.createElement('canvas');

            this.canvas.width = this.video.videoWidth;
            this.canvas.height = this.video.videoHeight;
            this.canvas.getContext('2d').drawImage(this.video, 0, 0);
            // Other browsers will fall back to image/png
            this.img.src = this.canvas.toDataURL('image/png');
            
            this.showCameraScreen = false
            this.showScreenshot = false
            this.showSavePic = true
        },
        takeAgain() {
            this.showImage = false
            this.showSavePic = false
            this.turnOffDevice()
            this.turnOnVideo(this.action, this.transDate)
        },
        turnOffDevice() {
            if (this.videoStream!==null) {
                this.videoStream.getTracks().forEach((track) => {
                    track.stop()
                });
            }
        },
        turnOnVideo() {
            try {
                this.error = false
                this.showCameraScreen = true
                this.showCameraButton = false
                this.showUpload = false
                this.showScreenshot = true
                this.loadingScreenshot = true

                const constraints = {
                    video: {width: {exact: 440}, height: {exact: 360}}
                };
                this.video = document.querySelector('video');

                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {
                        this.video.srcObject = stream
                        this.videoStream = stream
                        this.loadingScreenshot = false
                    });
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        fileAdded(file) {
            this.loading = true
        },            
        closeDialog() {
            this.turnOffDevice()

            this.showUpload = true
            this.showCameraScreen = false
            this.showCameraButton = true
            this.showScreenshot = false
            this.showImage = false
            this.showSavePic = false
            this.networkError = false

            this.$emit('update:dialogEditAvatar', false)     
        }
    },        
    created() {
        this.userId = this.$store.state.userId
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
    },
    destroyed() {
        this.turnOffDevice()
    }
}
</script>
<style scoped>
.editavatar_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
}
.img-viewer {
    max-width:1000px;
    text-align:center;
    border-radius:4px;
}
.img-controls {
    position: absolute; 
    bottom: 0; 
    left: 50%; 
    transform: translateX(-50%); 
    width: 100%; 
    padding: 10px 10px 20px 10px;
}
</style>